export enum JobPricingReportViewBy {
  JOB = "Job",
  FUNCTION = "Function",
  GRADE = "Grade"
}

export enum JobPricingSections {
  FUNCTION_TITLE = "functionTitle",
  JOB_TITLE = "jobTitle",
  GRADE = "grade"
}

export interface JobPricingCustomGrade {
  value: string;
  name: string;
  high: number;
  middle: number;
  low: number;
}

export interface PriorYearDataModels {
  percentage: number;
  percentageStatus: string;
  status: string;
}

export interface InsightsContentData {
  currentYearData: JobPricingReportDetails | null;
  previousYearData: PriorYearDataModels | null;
}

export interface JobPricingContextState {
  lineChartRef: Highcharts.Chart | null;
  barChartRef: Highcharts.Chart | null;
  insightsContent: InsightsContentData;
  setLineChartReference: (chartRef: Highcharts.Chart) => void;
  setBarChartReference: (chartRef: Highcharts.Chart) => void;
  setInsightsContentData: (data: InsightsContentData) => void;
}

export interface JobPricingHeaderDetails {
  title: string;
  description?: string;
  jobCode?: string;
  grade?: string;
  gradeSpan?: string;
  stage?: string;
  function?: string;
  subFunction?: string;
  totalJobs?: string;
  orgJobs?: string;
}

export interface JobPricingPercentileData {
  percentile: string;
  percentileDisplay: string;
}

export interface JobPricingPercentileDetails {
  percentileValue: string;
  marketValue: number | null;
  clientValue: number | null;
}

export interface JobPricingReportDetails {
  compensationFactKey: number;
  factName: string;
  orgs: string;
  incumbents: string;
  marketPositions: string;
  marketValues: string;
  orgEffectiveDate: string;
  clientValues: string;
  marketEffectiveDate: string;
  targetMarket?: number;
  targetOrg?: number;
  avgMarket?: number;
  avgMarketPercentage?: number;
  avgOrg?: number;
  avgOrgPercentage?: number;
  percentileDetails?: JobPricingPercentileDetails[];
  orgAvgSalaryPercentage?: number;
  orgAvgSalaryValue?: string;
  orgAvgSalaryStatus?: string;
  marketCount?: number;
  clientCount?: number;
}

export interface SuccessProfileDetailsQueryParams {
  countrycode: string;
  language: string;
  jobcode: string;
  grade: string;
}

export interface SkillsData {
  name: string;
  level: number;
  description: string;
}

export interface BehavioralCompetenciesData {
  name: string;
  level: number;
  description: string;
}

export interface SuccessProfileDetails {
  jobSummary: string;
  skills: SkillsData[];
  behavioralCompetencies: BehavioralCompetenciesData[];
}

export interface JobPricingDetailsState {
  reportViewBy: string;
  headerDetails: JobPricingHeaderDetails;
  percentileDataList: JobPricingPercentileData[];
  targetData: JobPricingPercentileData;
  reportDetails: JobPricingReportDetails[];
  previousYearReportDetails: JobPricingReportDetails[];
  isViewSuccessProfile: boolean;
  isToggleTableView: boolean;
  publicationMarketDate: string;
  submissionOrgDate: string;
  showTableCompElements: string[];
  showSelectedPercentileList: JobPricingPercentileData[];
  isReturnToDataList: boolean;
  clientName: string;
  isPercentileDataLoading?: boolean;
  isReportDetailsLoading?: boolean;
  isSuccessProfileDetailsLoading?: boolean;
  successProfileDetails?: SuccessProfileDetails | null;
  isReportDetailsApiFailed?: boolean;
}

export interface JobPricingReportDetailsData {
  clientName: string;
  pricingDetail: JobPricingReportDetails[];
}

export interface JobPricingPercentileDataResponse {
  data: JobPricingPercentileData[];
  responseCode: number;
  responseMessage: string;
}

export interface JobPricingReportDetailsResponse {
  data: JobPricingReportDetailsData;
  responseCode: number;
  responseMessage: string;
}

export interface SuccessProfileDetailsResponse {
  data: SuccessProfileDetails;
  responseCode: number;
  responseMessage: string;
}
